import { primitiveColorTokens, tokens } from '@cellula/react-theme-patient';
import { styled } from 'styled-components';
import { Nav } from './nav.components';

interface Props {}

const StyledTabBar = styled(Nav.Content)`
	display: flex;
	flex-direction: row;
	align-self: center;
	position: fixed;
	gap: ${tokens.spacing.x1};
	bottom: 0;
	padding: 8px;
	width: 100vw;
	justify-content: space-evenly;
	z-index: 1;
	background: ${tokens.color.bg.surface};
	box-shadow: ${tokens.elevation.skim};
	border: 1px solid ${tokens.color.border.muted};

	/* &:after {
		content: '';
		border: 1px solid ${primitiveColorTokens.primary[200]};
		border-bottom: none;
		border-top-right-radius: 5px;
		border-top-left-radius: 5px;
		margin: 0 -1px;

		position: absolute;
		inset: 0;
		z-index: -1;

		--extended-by: 150px;
		bottom: calc(-1 * var(--extended-by));
		top: -1px;

		--cutoff: calc(100% - var(--extended-by));

		-webkit-mask-image: linear-gradient(to bottom, black 0, black var(--cutoff), transparent var(--cutoff));

		--blur: 15px;
		backdrop-filter: blur(var(--blur));
		-webkit-backdrop-filter: blur(var(--blur));

		background: linear-gradient(180deg, #fff 10%, transparent 100%);

		user-select: none;

		${tokens.breakpointQuery.small} {
			border: 0;
		}
	} */

	/* ${tokens.breakpointQuery.medium} {
		margin-bottom: 40px;
		max-width: 400px;
		border-radius: 999px;
		overflow: hidden;
		border: 1px solid ${primitiveColorTokens.primary[200]};
	} */
`;

export function TabBar(_: Props) {
	return (
		<Nav.Root>
			<StyledTabBar>
				<Nav.ItemReception />
				<Nav.ItemSearchReception />
				<Nav.ItemVisits />
			</StyledTabBar>
		</Nav.Root>
	);
}
